<template>
  <HomepageFeatureSection
    title="Move money, but smarter"
    body="Transfer between any financial account or pay down student loans, one-time or on a recurring basis."
    color="var(--colorSwissTeal300)"
  >
    <TransferListItem
      v-for="transfer in transfers"
      :key="transfer.EraFundsTransferId"
      class="HomepageTransfersFeatureSection__transfer"
      :modelValue="transfer"
      v-bind="{accountMap}"
    />
  </HomepageFeatureSection>
</template>

<script lang="ts" setup>
import HomepageFeatureSection from "@cosine/components/homepage/HomepageFeatureSection.vue";
import TransferListItem from "@cosine/components/TransferListItem.vue";
import useLiveTime from "@cosine/composables/useLiveTime";
import { createEnrichedFinancialAccount } from "@cosine/tests/factories/FinancialAccountFactory";
import { createTransfer } from "@cosine/tests/factories/FundsTransferFactory";
import { FundsTransferState } from "@cosine/types/api-models";
import { subDays, subMinutes } from "date-fns";
import { computed, ref } from "vue";

const {
  now,
} = useLiveTime();

const accounts = ref([
  createEnrichedFinancialAccount({
    EraAccountId: "account123",
    DisplayName: "Chase",
    Nickname: "7495",
  }),
  createEnrichedFinancialAccount({
    EraAccountId: "account456",
    DisplayName: "Wells Fargo",
    Nickname: "3942",
  }),
  createEnrichedFinancialAccount({
    EraAccountId: "account789",
    DisplayName: "Student loan",
    Nickname: "9374",
  }),
]);
const accountMap = ref(new Map(accounts.value.map((account) => {
  return [account.EraAccountId, account];
})));

const transfers = computed(() => {
  return [
    createTransfer({
      SourceEraAccountId: accounts.value[0].EraAccountId,
      DestinationEraAccountId: accounts.value[1].EraAccountId,
      Amount: 500_00,
      State: FundsTransferState.Pending,
      RequestedAt: subMinutes(now.value, 15).toISOString(),
    }),
    createTransfer({
      SourceEraAccountId: accounts.value[0].EraAccountId,
      DestinationEraAccountId: accounts.value[2].EraAccountId,
      Amount: 1000_00,
      State: FundsTransferState.Completed,
      RequestedAt: subDays(now.value, 2).toISOString(),
    }),
  ];
});
</script>

<style lang="scss" scoped>
.HomepageTransfersFeatureSection__transfer {
  padding-inline: 0;
}
</style>
